import { CASES, LIGHTHOUSE } from "@/data/content";
import { SectionHeading, CTAButton, Eyebrow } from "./ui";
import { Reveal } from "./Reveal";
import { Check } from "lucide-react";

export function CaseStudiesSection() {
  return (
    <section className="relative bg-brand-cream py-20 lg:py-32 grain-overlay">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <SectionHeading eyebrow={CASES.eyebrow} title={CASES.title} />
        <Reveal delay={2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-brand-graphite/75">{CASES.body}</p>
        </Reveal>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {[0, 1, 2].map((i) => (
            <Reveal key={i} delay={i}>
              <div
                data-testid={`case-placeholder-${i}`}
                className="flex aspect-[4/3] flex-col items-center justify-center rounded-sm border border-dashed border-brand-bordeaux/25 bg-brand-ivory/50 p-6 text-center"
              >
                <span className="font-mono text-[11px] uppercase tracking-editorial text-brand-gold">
                  Case study in costruzione
                </span>
                <p className="mt-3 text-xs text-brand-graphite/45">{CASES.placeholder}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={1}>
          <div className="mt-10">
            <CTAButton href="#lead" variant="outline" data-testid="cases-cta">
              {CASES.cta}
            </CTAButton>
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function LighthouseSection() {
  return (
    <section className="relative bg-brand-wine py-20 lg:py-32 grain-overlay overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <Reveal><Eyebrow>{LIGHTHOUSE.eyebrow}</Eyebrow></Reveal>
            <Reveal delay={1}>
              <h2 className="mt-6 font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-brand-ivory">
                {LIGHTHOUSE.title}
              </h2>
            </Reveal>
            <Reveal delay={2}>
              <p className="mt-6 max-w-xl text-base leading-relaxed text-brand-ivory/75">{LIGHTHOUSE.body}</p>
            </Reveal>
            <Reveal delay={2}>
              <div className="mt-8">
                <CTAButton href="#lead" variant="gold" data-testid="lighthouse-cta">
                  {LIGHTHOUSE.cta}
                </CTAButton>
              </div>
            </Reveal>
          </div>
          <Reveal delay={1} className="lg:col-span-5">
            <div className="rounded-sm border border-brand-ivory/15 bg-brand-bordeaux/40 p-8">
              <span className="text-[10px] uppercase tracking-editorial font-semibold text-brand-gold">
                Requisiti indicativi
              </span>
              <ul className="mt-6 space-y-4">
                {LIGHTHOUSE.requirements.map((req) => (
                  <li key={req} className="flex items-start gap-3 text-sm text-brand-ivory/85">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" />
                    {req}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
